import type { ConditionExtension as ConditionModel } from 'tio-data/data/resources/condition.ext';

/**
 * Minimal slice of ember-intl's service needed to resolve a title — keeps the
 * resolver a pure function so it can be unit-tested without booting the app.
 */
interface IntlLike {
  exists(key: string): boolean;
  t(key: string): string;
}

type TitleableCondition = Pick<ConditionModel, 'province' | 'prompt'>;

/** i18n key for a condition's concise, per-stage document title. */
export function conditionTitleKey(condition: Pick<ConditionModel, 'province'>): string {
  return `tas.terms_titles.${condition.province}`;
}

/**
 * Concise document title for a Terms & Conditions row, keyed off the
 * condition's `province`. Falls back to the admin-authored `prompt` when the
 * province is missing or has no mapped title, so a row can never render an
 * empty or raw i18n key.
 */
export function conditionDisplayTitle(intl: IntlLike, condition: TitleableCondition): string {
  const key = conditionTitleKey(condition);
  return condition.province && intl.exists(key) ? intl.t(key) : condition.prompt;
}
